import styled, { css } from 'styled-components';
import {
  Flex,
  isDarkThemeMixin,
  Link,
  Popover,
  styleMixinFocusOutline,
  styleMixinInvertedFocusOutline,
  TextButton,
} from '@amzn/storm-ui';

export const StyledLink = styled(Link)`
  text-decoration: none;

  &:hover {
    text-decoration: underline;
  }

  &&:focus-visible {
    ${styleMixinInvertedFocusOutline};

    ${isDarkThemeMixin(css`
      ${styleMixinFocusOutline};
    `)};
  }
`;

export const StyledTextButton = styled(TextButton)`
  color: ${({ theme }) => theme.text.color.inverted};

  ${isDarkThemeMixin(css`
    color: ${({ theme }) => theme.text.color.default};
  `)};

  &:hover {
    color: ${({ theme }) => theme.text.color.inverted};
    text-decoration: underline;

    ${isDarkThemeMixin(css`
      color: ${({ theme }) => theme.text.color.default};
    `)};
  }

  &:focus-visible {
    ${styleMixinInvertedFocusOutline};

    ${isDarkThemeMixin(css`
      ${styleMixinFocusOutline};
    `)};
  }
`;

export const EllipsisButton = styled(TextButton)`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 42px;
  height: 18px;
  background-color: transparent;
  color: ${({ theme }) => theme.text.color.inverted};
  border-radius: ${({ theme }) => theme.border.radius.small};
  box-shadow: 0 0 0 0 rgba(255, 255, 255, 0);

  &:hover {
    color: ${({ theme }) => theme.text.color.inverted};
    background-color: ${({ theme }) => theme.color.gray[1000]};
  }

  &&:focus-visible {
    ${styleMixinInvertedFocusOutline};
  }

  ${isDarkThemeMixin(css`
    color: ${({ theme }) => theme.icon.color.default};

    &:hover {
      color: ${({ theme }) => theme.text.color.default};
    }

    &&:focus-visible {
      ${styleMixinFocusOutline};
    }
  `)};
`;

export const TruncatedPopper = styled(Popover)`
  z-index: 599;

  && svg {
    opacity: 1;
  }
`;

export const TruncatedBreadcrumbWrapper = styled(Flex)`
  overflow: hidden;
  white-space: nowrap;
  flex: auto;

  && a {
    color: ${({ theme }) => theme.text.color.inverted};
  }

  & p {
    color: ${({ theme }) => theme.text.color.unavailableInverted};
  }

  ${isDarkThemeMixin(css`
    && a {
      color: ${({ theme }) => theme.text.color.default};
    }

    & p {
      color: ${({ theme }) => theme.text.color.unavailable};
    }
  `)};
`;

export const VisibilityWrapper = styled.div`
  display: flex;
  position: absolute;
  visibility: hidden;
`;

export const OuterContainer = styled.div<{
  noPageTitleBreadcrumb?: boolean;
}>`
  flex: auto;
  overflow: hidden;

  & nav {
    flex-wrap: nowrap;
    overflow: hidden;
    flex: auto;
    padding-right: ${({ theme }) => theme.spacing.xsmall.default};
    ${(props) =>
      props.noPageTitleBreadcrumb &&
      css`
        & i:last-of-type {
          padding-right: 0;
        }
      `}
  }
`;

export const SingleBreadcrumbWrapper = styled.span`
  & i:first-of-type {
    padding-left: 0;
  }

  & nav {
    flex-wrap: nowrap;
    overflow: hidden;
    flex: auto;
    padding-right: ${({ theme }) => theme.spacing.xsmall.default};
  }
`;

export const BreadcrumbGroupWrapper = styled.div`
  && a {
    color: ${({ theme }) => theme.link.color.default};
  }
`;
